import React from 'react';

import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import ErrorIcon from '../../../../../assets/images/icon_error_messages.gif';
import { sortedObjects } from '../../../../utils/utils';
import Label from '../../../../registration/fields/common/label';

const DealershipField = ({
  label,
  errors,
  touched,
  values,
  setFieldValue,
  dealershipNames
}) => {
  const dealershipList = sortedObjects(dealershipNames, 'name').map(
    ({ id, name }) => {
      return { id, label: name };
    }
  );

  return (
    <>
      <Label labelName={label} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${
          errors.dealership && touched.dealership ? 'error' : ''
        }`}
      >
        <Typeahead
          id="dealership"
          labelKey="label"
          options={dealershipList}
          onChange={setFieldValue}
          placeholder="Select dealership"
          selected={values.dealership || []}
          clearButton
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.dealership}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

DealershipField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  dealershipNames: PropTypes.isRequired
};

export default DealershipField;
